/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { getApiHost } from 'cio/utils/data-centers';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import { LoadApiCredentialsYield } from 'cio/utils/components/load-api-credentials';

interface FormsCustomIntegrationDetailsTypeformArgs {
  onCopy: () => unknown;
  credentials: LoadApiCredentialsYield;
  isBlankSlate: boolean;
  compact?: boolean;
}
export default class FormsCustomIntegrationDetailsTypeform extends Component<FormsCustomIntegrationDetailsTypeformArgs> {
  @service account!: AccountService;

  get trackAPISubmitURL() {
    // eslint-disable-next-line no-useless-escape
    return `https:\/\/${getApiHost(
      'track',
      this.account.current?.dataCenter ?? '',
    )}.customer.io/forms/submit_typeform?site_id=${this.args.credentials.selected?.siteId ?? '…'}`;
  }
}
